import classNames from 'classnames';
import I18n from '../../config/i18n';
import { getLimitationName, renderValue, renderInfo } from '../../helper/HostDetails';

import './details-list-table.css';

/* eslint-disable camelcase */

export type DetailsListData = DetailsListValue | DetailsListPrice;

interface DetailsListValue {
  label: string;
  value: string | number;
  info: string | number;
  limitation: boolean;
  alert?: 'success' | 'warning' | 'danger';
}

interface DetailsListPrice {
  label: string;
  price: string;
  price_winter: string | null;
  info: string;
}

interface DetailsListProps {
  data?: DetailsListData[];
}

function DeatilsListValueData({ listData }: { listData: DetailsListValue }): JSX.Element {
  const { value, info, limitation, alert } = listData;

  if (alert) {
    return <dd className={classNames('details-list-value', alert)}>{listData.value}</dd>;
  }
  return (
    <dd className={classNames('details-list-value', getLimitationName(value, limitation))}>
      {renderValue(value, limitation)}
      <div className="details-list-info">{renderInfo(info, limitation)}</div>
    </dd>
  );
}

function DeatilsListPriceData({ listData }: { listData: DetailsListPrice }): JSX.Element {
  const { price, price_winter, info } = listData;

  if (price_winter == null) {
    return (
      <dd className="details-list-value">
        <div>{price}</div>
        <div className="details-list-info">{info}</div>
      </dd>
    );
  }

  return (
    <dd className="details-list-value">
      <div>{price}</div>
      <div className="details-list-info details-list-info-summer">
        {info} {I18n.t('host.summer_price')}
      </div>
      <div>{price_winter}</div>
      <div className="details-list-info">
        {info} {I18n.t('host.winter_price')}
      </div>
    </dd>
  );
}

export default function DetailsList({ data }: DetailsListProps): JSX.Element {
  return (
    <dl className="details-list">
      {data &&
        data.map((listData) => (
          <div key={listData.label} className="details-list-entry">
            <dt className="details-list-label">{listData.label}:</dt>
            {'value' in listData ? (
              <DeatilsListValueData listData={listData} />
            ) : (
              <DeatilsListPriceData listData={listData} />
            )}
          </div>
        ))}
    </dl>
  );
}

const defaultProps: Pick<DetailsListProps, 'data'> = {
  data: [],
};

DetailsList.defaultProps = defaultProps;
